var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDebits({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 145.5 145.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 21.35,
    y1: 124.15,
    x2: 124.15,
    y2: 21.35,
    gradientTransform: "translate(121.8 -17.69) rotate(73.47)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9748a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d163ab"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 38.59,
    y1: 106.91,
    x2: 106.91,
    y2: 38.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#edbede"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 72.75,
    cy: 72.75,
    r: 72.75,
    transform: "translate(-17.69 121.8) rotate(-73.47)",
    fill: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.23,78.1v-30.43c0-2.34-1.92-4.25-4.26-4.25-1.12,0-2.21,.45-3.01,1.25l-6.51,6.52c-6.37-5.8-13.91-10.41-21.95-13.41-4.17-1.58-8.52-2.38-12.95-2.38-8.97,0-17.58,3.3-24.25,9.29-.95,.81-1.5,1.99-1.5,3.24,0,2.35,1.91,4.26,4.31,4.26,.04,0,.07,0,.11,0,.75-.03,1.52-.05,2.27-.05,14.06,0,27.42,5.86,36.93,16.14l-7.11,7.11c-.79,.79-1.25,1.89-1.25,3.01,0,2.35,1.91,4.26,4.27,4.26h30.66c2.34,0,4.25-1.91,4.26-4.26,0-.1,0-.2-.02-.29Zm-5-.45h-28.13l7.54-7.54c.47-.47,.73-1.1,.73-1.77s-.26-1.3-.73-1.77l-.27-.27c-10.59-12.28-25.96-19.31-42.22-19.18,5.52-4.36,12.33-6.74,19.41-6.74,3.82,0,7.57,.69,11.18,2.06,8.17,3.05,15.79,7.89,22.01,14,.98,.96,2.55,.95,3.52-.02l6.96-6.97v28.19Zm-7.84,15.67s-.07,0-.11,0c-.75,.03-1.52,.05-2.27,.05-14.06,0-27.42-5.86-36.93-16.14l7.11-7.11c.79-.79,1.25-1.89,1.25-3.01,0-2.35-1.91-4.26-4.27-4.26h-30.66c-2.35,0-4.26,1.91-4.26,4.26,0,.09,0,.19,.02,.28v30.44c0,2.34,1.92,4.25,4.26,4.25,1.12,0,2.22-.45,3.01-1.25l6.51-6.52c6.37,5.8,13.91,10.41,21.95,13.41,4.17,1.58,8.52,2.38,12.95,2.38,8.97,0,17.58-3.3,24.25-9.29,.95-.81,1.5-1.99,1.5-3.24,0-2.35-1.91-4.26-4.31-4.26Zm-21.44,11.79c-3.82,0-7.57-.69-11.18-2.06-8.17-3.05-15.78-7.89-22.01-14-.49-.48-1.12-.72-1.75-.72s-1.28,.24-1.77,.73l-6.96,6.97v-28.19h28.13l-7.54,7.54c-.98,.98-.98,2.56,0,3.53l.27,.27c10.52,12.19,25.78,19.18,41.88,19.18,.11,0,.23,0,.34,0-5.52,4.36-12.33,6.74-19.41,6.74Z",
    fill: "url(#e)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDebits);
export default __webpack_public_path__ + "static/media/debits.5eee570b33496688fd41b0304a3f61a3.svg";
export { ForwardRef as ReactComponent };